import { SWRResponse } from 'swr';
import useSWRImmutable from 'swr/immutable';

import { File } from 'models';

import { FileService } from 'services/FileService';

import { prepareConditionalSwrArgs } from './prepare-conditional-swr-args';

const useFile = (
    file?: any,
): SWRResponse & {
    file: File;
} => {
    const swr = useSWRImmutable(
        ...prepareConditionalSwrArgs({
            key: `/files/${file}`,
            fetcher: () => FileService.get(file),
            condition: file && typeof file === 'string',
        }),
    );

    return {
        ...swr,
        file: swr?.data ?? (typeof file === 'object' && file),
    };
};

export { useFile };
